module.exports = __webpack_public_path__ + "static/media/p2.0fc8656a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/p2.png
// module id = 266
// module chunks = 0